import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";

export default function RolesInfo() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/settings/roles")
      .then((r) => setRows(r.data || []))
      .catch((e) => toast.error(e.response?.data?.detail || "Could not load roles"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-4" data-testid="settings-roles">
      <div className="rounded-md bg-[#F1FAEE] border border-[#a8dadc]/40 px-3 py-2 text-[12px] text-[#457b9d]">
        The 10 Fender roles are hard-coded and maintained by SparesHub. You can assign them to users but cannot rename or edit their access.
      </div>

      <section className="bg-white rounded-xl border border-[#E4E7EC]">
        {loading ? (
          <div className="p-10 text-center text-[13px] text-[#667085]">Loading roles…</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-[13px]" data-testid="roles-table">
              <thead>
                <tr className="text-left text-[10.5px] uppercase tracking-wider font-semibold text-[#667085] border-b border-[#F1FAEE]">
                  <th className="px-5 py-2.5">Role</th>
                  <th className="px-3 py-2.5">Description</th>
                  <th className="px-3 py-2.5">Main access areas</th>
                  <th className="px-5 py-2.5 text-right">Users</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.key} className="border-b border-[#F1FAEE] last:border-0 align-top">
                    <td className="px-5 py-3">
                      <div className="flex items-start gap-2">
                        <div className="w-7 h-7 rounded-md bg-[#457b9d]/12 text-[#1d3557] grid place-items-center mt-0.5">
                          <ShieldCheck size={12} />
                        </div>
                        <div>
                          <div className="font-bold text-[#1d3557]">{r.label}</div>
                          <div className="text-[10.5px] font-mono text-[#667085]">{r.key}</div>
                        </div>
                      </div>
                    </td>
                    <td className="px-3 py-3 text-[12.5px] text-[#1d3557] max-w-md">{r.description}</td>
                    <td className="px-3 py-3">
                      <div className="flex flex-wrap gap-1">
                        {(r.areas || []).map((a) => (
                          <span key={a} className="inline-flex px-2 py-0.5 rounded-full text-[10.5px] font-semibold bg-[#F1FAEE] text-[#457b9d]">
                            {a}
                          </span>
                        ))}
                      </div>
                    </td>
                    <td className="px-5 py-3 text-right">
                      <span className="inline-flex h-7 min-w-7 px-2 rounded-full bg-[#1d3557] text-white text-[12px] font-bold items-center justify-center font-mono">
                        {r.assigned_count}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </div>
  );
}
